import { MenuDivider, MenuItem } from "@blueprintjs/core";

import { MoreMenu } from "@/components/pieces/more/MoreMenu";
import { EvaluationCriterionFieldsFragment } from "@/graphql";

import { useEvaluationCriteriaItemModalsContext } from "./EvaluationCriteriaItemModals";

interface EvaluationCriteriaMenuProps {
  criterion: EvaluationCriterionFieldsFragment;
  canDelete?: boolean;
  refetch: () => void;
  entityType: "rubric" | "scenario";
}

export function EvaluationCriteriaMenu(props: EvaluationCriteriaMenuProps) {
  const { canDelete = false, criterion } = props;
  const {
    openEditLabel,
    openAddItem,
    openDeleteCriterion,
    openUnlinkCriterion,
  } = useEvaluationCriteriaItemModalsContext();

  const isLinked = criterion.isLinked;
  const isScenario = props.entityType === "scenario";

  return (
    <MoreMenu>
      {!isLinked && (
        <MenuItem onClick={() => openEditLabel()} text="Edit Label" />
      )}
      <MenuItem onClick={() => openAddItem()} text="Add Item" />
      {isLinked && isScenario && (
        <>
          <MenuDivider />
          <MenuItem
            onClick={() => openUnlinkCriterion()}
            text="Unlink from Rubric"
          />
        </>
      )}
      {canDelete && (
        <>
          <MenuDivider />
          <MenuItem
            onClick={() => openDeleteCriterion()}
            intent="danger"
            text="Remove Criteria"
          />
        </>
      )}
    </MoreMenu>
  );
}
